import React, { useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Banner from '../components/Banner';
import BackToTop from '../components/BackToTop';
import { WOW } from 'wowjs';
import '../css/global.css';
import '../css/Opportunities.css';

const Opportunities = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
        const wow = new WOW({
            live: false
        });
        wow.init();
    }, []);

    return (
        <div className="opportunities-page">
            <Header />
            
            <Banner 
                backgroundImage="/wp-content/uploads/2016/08/TRAINEES-v1.jpg" 
            />

            <section className="contentwrapper clearfix">
                <div className="content clearfix">
                    
                    <div className="header-container">
                        <div className="breadcrumbs">
                            <a href="/">Home</a> &gt; <span>Opportunities</span>
                        </div>
                        <h1 data-aos="fade-right">Opportunities</h1>
                    </div>

                    {/* Section 1: CTA (Navy) */}
                    <div className="opp-cta-section" data-aos="fade-up">
                        <div className="vc_row-inner">
                            <p>We are looking for motivated and qualified individuals to join our team. If interested, please submit your CV via the official application format only, and we will consider you for future job vacancies.</p>
                            <a className="dwnload-link" href="/wp-content/uploads/2018/08/Colombo-Dockyard-PLC-Official-Application-Format.docx">
                                Click here to download the official application format <i className="fas fa-download"></i>
                            </a>
                            <p className="email-text">Please send us your application to <strong>hrd@cdl.lk</strong></p>
                        </div>
                    </div>

                    {/* Section 2: Vision & Objective */}
                    <div className="opp-vision-objective">
                        <div className="opp-vision-col" data-aos="fade-right">
                            <h2>HRD VISION</h2>
                            <p>To develop the “New CDPLC Man” who is economically stable, socially responsible, organizationally loyal, internally disciplined, technically competent, functionally knowledgeable, operationally productive and equipped with shared goals in order to play a lead role in the organizational HR transformation process.</p>
                        </div>
                        <div className="opp-objective-col" data-aos="fade-left">
                            <h2>CORE HRD OBJECTIVE</h2>
                            <p>To reach a true HR transformation with an integrated, innovative and business focused approach to redefine how HRM is done within the organization, so that it helps the organization deliver its promises made to customers, investors, employees and other stakeholders.</p>
                        </div>
                    </div>

                    {/* Section 3: Strategic Header (Navy) */}
                    <div className="opp-strategic-header" data-aos="fade-up">
                        <div className="vc_row-inner">
                            <h2>Our Key Strategic HRM Domains and HR Plan</h2>
                            <p>With the timely concern of business focus of the organization there are 04 key strategic domains that have been identified in the CDPLC HR Plan.</p>
                        </div>
                    </div>

                    {/* Section 4: Domains Grid */}
                    <div className="opp-domains-grid">
                        <div className="opp-domain-item" data-aos="fade-up" data-aos-delay="100">
                            <h3>1. COMPETENCE</h3>
                            <p>CDPLC Training Centre (TRC) is playing a crucial role in catering the required skilled manpower in meeting the company’s increasing production demands. The management pays special emphasis in upgrading the skill level of employees through a nationally recognized framework, viz. the National Vocational Qualification (NVQ).</p>
                        </div>
                        <div className="opp-domain-item" data-aos="fade-up" data-aos-delay="150">
                            <h3>3. EMPLOYEE ENGAGEMENT</h3>
                            <p>One of our main strategic goals is to ensure that employees are committed to the organisation’s goals and values, motivated to contribute to organisational success, and are able at the same time to enhance their own sense of well-being.</p>
                        </div>
                        <div className="opp-domain-item" data-aos="fade-up" data-aos-delay="200">
                            <h3>2. INDUSTRIAL RELATIONS</h3>
                            <p>In our point of view Industrial Relations are the relationships between employees and the management within the organizational settings. In our organizational structure industrial relations look at the relationship between management and workers, particularly groups of workers represented by a union. Since this is one of our major strategic concerns HRD gives high priority to sustain good industrial harmony in the organization.</p>
                        </div>
                        <div className="opp-domain-item" data-aos="fade-up" data-aos-delay="250">
                            <h3>4. TRANSFORMATION</h3>
                            <p>Transforming employees through innovative HR initiatives is one of our major strategic goals. Therefore, our transformation strategy is to carefully handle HR components such as processes, tools and people, and then integrate these components into an overall HR capability model which enables the organization to sustain flexible work force to face global challenges.</p>
                        </div>
                    </div>

                    {/* Section 5: Summary (Gray) */}
                    <div className="opp-bottom-summary" data-aos="fade-up">
                        <div className="vc_row-inner">
                            <p>We need to shape our strategies with response to our business requirement as we are in a rapidly changing business environment. Therefore, in most extent we need to take timely decisions to change and shape our HR strategies with response to our business environment. <strong>In this sense above four strategic domains reflect our contemporary business requirement.</strong></p>
                            <p>Under the broad HRD vision we are trying to craft a competent, transformational, engaged workforce in the sphere of positive industrial relations. This workforce is the major pillar of the production process. Therefore, we believe that strategies emanating from the above domains pave the way for achieving our intended business goals and organizational growth, while countering external and internal challenges and competition.</p>
                        </div>
                    </div>

                </div>
            </section>

            <Footer />
            <BackToTop />
        </div>
    );
};

export default Opportunities;
